import { combineReducers } from 'redux';

import biometricsAuthenticationReducer from './biometricsAuthenticationReducer';
import desktopSessionReducer from './desktopSessionReducer';
import desktopSessionLoadingReducer from './desktopSessionLoadingReducer';
import devicesReducer from './devicesReducer';
import rdcErrorReducer from './rdcErrorReducer';
import loadingReducer from './loadingReducer';
import metadataReducer from './metadataReducer';
import mobileAppsReducer from './mobileAppsReducer';
import mobileDrawerReducer from './mobileDrawerReducer';
import mobileLogReducer from './mobileLogReducer';
import mobileVitalsReducer from './mobileVitalsReducer';
import mobileSessionReducer from './mobileSessionReducer';
import rdcDevicePickerReducer from './rdcDevicePickerReducer';

const manualReducer = combineReducers({
  biometricsAuthentication: biometricsAuthenticationReducer,
  apps: mobileAppsReducer,
  desktopSession: desktopSessionReducer,
  desktopSessionLoading: desktopSessionLoadingReducer,
  devices: devicesReducer,
  rdcError: rdcErrorReducer,
  loading: loadingReducer,
  metadata: metadataReducer,
  session: mobileSessionReducer,
  drawer: mobileDrawerReducer,
  log: mobileLogReducer,
  vitals: mobileVitalsReducer,
  rdcDevicePicker: rdcDevicePickerReducer,
});

export default manualReducer;
